import React from 'react';

import SelectOfferContent from './SelectOfferContent';
import { Offer } from '../../hooks';

export type SelectOfferModalProps = {
    offers: Array<Offer>;
    currentOffer?: Offer;
    onSubmit: (offer?: Offer) => void;
};

const SelectOfferModal: React.FunctionComponent<SelectOfferModalProps> = function (props) {
    const { currentOffer, offers, onSubmit } = props;

    const handleSelectOffer = (offer?: Offer) => {
        if (offer?.id !== currentOffer?.id) {
            onSubmit(offer);
        }
    };

    return (
        <SelectOfferContent
            offers={offers}
            selectedOfferId={currentOffer?.id}
            onSelectOffer={handleSelectOffer}
        />
    );
};

export default SelectOfferModal;
